module.exports = __webpack_public_path__ + "img/__5.2150a826.png";